<template>
  <div v-if="calc" class="shared-calculation">
    <div class="share-ment">
      <span class="information">
        {{ $t('shared_calculator.text.information') }}
      </span>
      <span class="information-guide">
        {{ $t('shared_calculator.guide.information') }}
      </span>
      <button class="hidden btn btn-sm btn-market" @click="openMarket($event)">
        {{ $t('shared_calculation.button.link') }}
      </button>
      <div
        v-if="calc.shareMent"
        class="share-ment-contents"
        v-html="escapeHtmlWithNewLine(calc.shareMent)"
      />
      <div class="clear"></div>
    </div>
    <div class="clear"></div>
    <div class="calculate-products">
      <div v-for="(grp, grpIndex) in productsGroups" :key="'products-group-' + grpIndex">
        <div v-if="getSelectedCountInGroup(grp.data) > 0" class="product-group">
          <img src="/img/calculator/ico_tile_logo.png" alt="Unistars" class="unistars-logo">
          <div class="group-title">
            <span class="first-character">{{ $t('code.nm.' + grp.grpCode).substring(0, 1) }}</span><span class="remained-character">{{ $t('code.nm.' + grp.grpCode).substring(1) }}</span>
          </div>
          <div v-for="(product, productIndex) in grp.data" :key="'product-' + productIndex">
            <div v-if="product.co" class="product">
              <div class="dot" />
              <div class="product-image" @click="showImageSlider(product, $event)">
                <img :src="getImgUrl(product.image)" :alt="product.nm">
              </div>
              <div class="product-title">
                {{ product.nm }}
              </div>
              <div class="prices">
                <div class="product-price product-value">
                  {{ $t('shared_calculator.text.member_price') }} :
                  {{ product.pc | formatNumber }}
                </div>
                <div v-if="calc.hideDscntPcFlag === 'N'" class="product-discount-price product-value">
                  {{ $t('shared_calculator.text.discount_price') }} :
                  {{ product.dscntPc | formatNumber }}
                </div>
                <div v-if="calc.hidePointFlag === 'N'" class="product-point product-value">
                  {{ $t('shared_calculator.text.point') }} :
                  {{ product.point | formatNumber }}P
                </div>
              </div>
              <div class="product-quantity">
                {{ $t('shared_calculator.text.count') }} :
                {{ product.co ? product.co : 0 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="shared-calc-footer">
      <div class="calc-summary">
        <div class="calc-summary-item">
          <div class="calc-summary-item-title">
            {{ $t('shared_calculator.text.member_price') }}
          </div>
          <div class="calc-summary-item-border product-price">
            <img src="/img/calculator/ico_cal.png" alt="Calculator">
            {{ getTotalPrice() | formatNumber }}
          </div>
        </div>
        <div v-if="calc.hideDscntPcFlag === 'N'" class="calc-summary-item">
          <div class="calc-summary-item-title">
            {{ $t('shared_calculator.text.discount_price') }}
          </div>
          <div class="calc-summary-item-border product-discount-price">
            <img src="/img/calculator/ico_cal.png" alt="Calculator">
            {{ getTotalDiscountPrice() | formatNumber }}
          </div>
        </div>
        <div v-if="calc.hidePointFlag === 'N'" class="calc-summary-item">
          <div class="calc-summary-item-title">
            {{ $t('shared_calculator.text.point') }}
          </div>
          <div class="calc-summary-item-border product-point">
            <img src="/img/calculator/ico_point.png" alt="Point">
            {{ getTotalPoint() | formatNumber }}P
          </div>
        </div>
      </div>
      <div class="wise-saying" v-html="$t('shared_calculator.text.ment')"></div>
      <div class="send-from" v-html="$t('shared_calculator.text.sent_from', { name: calc.userNm})"></div>
      <div class="clear" />
    </div>
    <div class="clear" />
    <b-modal
      ref="imageSliderRef"
      :title="targetProduct.nm"
      modal-class="dark-background-modal"
      ok-only
      :hide-footer="true"
      centered
      @shown="onImageSliderShown"
    >
      <div v-if="productImages" class="image-slider-area">
        <image-slider3d :contents="productImages" :width="800" />
      </div>
      <div class="justify-content-end d-flex height-3-rem">
        <b-button size="sm" @click="openURL(targetProduct.url, '_blank')">{{ $t('product.text.description') }}</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      calc: undefined,
      productsGroups: [],
      productImages: [],
      targetProduct: {}
    }
  },
  async mounted() {
    const res = await this.$axios.$get('/prduct/public/products', {
      no_loading: true
    })
    this.productsGroups = res.data
    const url = '/calc/public/calc?tmpId=' + this.$route.query.tid
    this.$axios.$get(url).then(response => {
      if (response.resultCode === 'success') {
        this.calc = response.data
        this.countProductsFrom(this.calc.calcProducts, 'prductId')
      } else {
        console.error(this.$t(response.message, response.params))
        this.$toast.error(this.$t(response.message, response.params))
      }
    })
    this.$eventHub.$emit('content-loaded')
  },
  methods: {
    openMarket(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (!this.calc || !this.calc.user) {
        this.$toast.info(this.$t('calc.notification.secessed_user'))
        return
      }
      let url = 'https://' + this.calc.user.userId + '.usana.com'
      if (this.calc.user.hmpgUrl && this.calc.user.hmpgUrl.trim()) {
        url = this.calc.user.hmpgUrl
      }
      window.open(url, '_blank')
    },
    showImageSlider(product, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.productImages = undefined
      this.showModal('imageSliderRef')
      this.targetProduct = product
    },
    onImageSliderShown() {
      this.productImages = this.targetProduct.image
      this.$forceUpdate()
    },
    getTotalPrice() {
      if (!this.productsGroups) {
        return 0
      }
      let ret = 0
      for (let i = 0; i < this.productsGroups.length; i++) {
        const grp = this.productsGroups[i]
        for (let j = 0; j < grp.data.length; j++) {
          const product = grp.data[j]
          if (!product.co) {
            product.co = 0
          }
          ret += product.pc * product.co
        }
      }
      return ret
    },
    getTotalDiscountPrice() {
      if (!this.productsGroups) {
        return 0
      }
      let ret = 0
      for (let i = 0; i < this.productsGroups.length; i++) {
        const grp = this.productsGroups[i]
        for (let j = 0; j < grp.data.length; j++) {
          const product = grp.data[j]
          if (!product.co) {
            product.co = 0
          }
          ret += product.dscntPc * product.co
        }
      }
      return ret
    },
    getTotalPoint() {
      if (!this.productsGroups) {
        return 0
      }
      let ret = 0
      for (let i = 0; i < this.productsGroups.length; i++) {
        const grp = this.productsGroups[i]
        for (let j = 0; j < grp.data.length; j++) {
          const product = grp.data[j]
          if (!product.co) {
            product.co = 0
          }
          ret += product.point * product.co
        }
      }
      return ret
    },
    countProductsFrom(list, key) {
      for (let i = 0; i < list.length; i++) {
        const calcProduct = list[i]
        if (!calcProduct.co) {
          continue
        }
        let found = false
        for (let j = 0; j < this.productsGroups.length; j++) {
          const grp = this.productsGroups[j]
          for (let k = 0; k < grp.data.length; k++) {
            const product = grp.data[k]
            if (product.id === calcProduct[key]) {
              found = true
              product.co = calcProduct.co
              break
            }
          }
          if (found) {
            break
          }
        }
      }
    },
    getSelectedCount() {
      let co = 0
      for (let i = 0; i < this.productsGroups.length; i++) {
        const grp = this.productsGroups[i]
        co += this.getSelectedCountInGroup(grp.data)
      }
      return co
    },
    getSelectedCountInGroup(data) {
      if (!data || data.length === 0) {
        return 0
      }
      let ret = 0
      for (let i = 0; i < data.length; i++) {
        const datum = data[i]
        if (datum.co) {
          ret += datum.co
        }
      }
      return ret
    }
  }
}
</script>

<style scoped>
.shared-calculation {
  padding-top: 0.5rem;
  background: #ededed;
}
.share-ment {
  background: #0545a2;
  background-image: url(/img/unistars/header_background.png);
  background-repeat: no-repeat;
  background-size: 100vw;
  background-position: 0 -9.4rem;
  padding: 3.375rem 1.08333rem 0.6rem;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  width: 100vw;
}
.share-ment .information {
  font-size: 1rem;
  color: #00f7d9;
}
.share-ment .information-guide {
  font-size: 0.88333rem;
  color: #ffffff;
  margin-left: 1rem;
}
.share-ment-contents {
  background: white;
  color: black;
  margin: 0.6rem 0;
  padding: 0.8333rem;
  font-size: 0.8333rem;
  word-break: break-all;
}
.calculate-products {
  background: #ffffff;
  padding: 0 1.6083rem 1.5416rem;
  margin-top: 0.5rem;
  border-radius: 0.5rem;
}
.product-group {
  padding-top: 1.5416rem;
  position: relative;
  width: auto;
}
>>> .carousel-3d-controls {
  opacity: 1;
}
>>> .carousel-3d-controls a:focus,
>>> .carousel-3d-controls a:hover,
>>> .carousel-3d-controls a:active {
  outline: none !important;
  box-shadow: none !important;
}
>>> .carousel-3d-slide {
  border: none !important;
  background: white !important;
  opacity: 0 !important;
}
>>> .carousel-3d-slide.current {
  opacity: 1 !important;
}
.product-group .unistars-logo {
  position: absolute;
  right: 0;
  top: 1.5416rem;
  width: 1.025rem;
  margin-top: 0.1rem;
}
.group-title {
  color: #360ea6;
  font-weight: bold;
  font-size: 0.95rem;
  margin-bottom: 0.4rem;
}
.group-title .first-character {
  font-size: 1.3333rem;
}
.group-title .remained-character {
  letter-spacing: 0.04rem;
}
.product {
  display: flex;
  align-items: center;
  height: 6rem;
  border-bottom: 1px solid #ececec;
}
.product-image {
  width: 5.48333rem;
}
.product-image img {
  width: 3.48333rem;
  margin: 0 1rem;
}
.product .dot {
  width: 0.1916rem;
  height: 0.1916rem;
  background: #b2b2b2;
  border-radius: 0.1rem;
}
.product-title {
  font-size: 0.883333rem;
  color: #2c2c2c;
  width: calc(100vw - 19rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.prices {
  width: 7rem;
}
.product-value {
  font-size: 0.625rem;
  text-align: left;
}
.product-price {
  color: #360ea6;
}
.product-discount-price {
  color: #e51010;
}
.product-point {
  color: #000000;
}
.product-quantity {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8333rem;
  width: 5rem;
  height: 1.483333333333333rem;
  border: 1px solid #bebebe;
}
.calc-summary {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #03ccc8;
  padding: 1rem;
}
.calc-summary img {
  height: 0.98rem;
}
.calc-summary-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: calc(100% / 3);
  font-size: 0.883333rem;
  padding: 0.1rem 0;
}
.calc-summary-item img {
  height: 1rem;
  margin-right: 1rem;
}
.calc-summary-item-border {
  border: none;
  background: white;
  border-radius: 0.275rem;
  padding: 0.39rem;
  width: 7.483rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.calc-summary-item-title {
  color: black;
  font-size: 0.625rem;
  width: 7.483rem;
}
.wise-saying {
  margin: 0.5rem 0 0.1rem;
  font-size: 0.675rem;
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
}
.send-from {
  font-size: 1.075rem;
  text-align: center;
  font-weight: bolder;
}
.shared-calc-footer {
  background: #ededed;
  padding-bottom: 1rem;
  height: 12rem;
}
.btn-market {
  background: #03ccc8;
  color: white;
  height: 2.5rem;
  margin-left: 0.3rem;
}
.btn-market:active,
.btn-market:focus,
.btn-market:hover {
  color: white;
}
</style>
